import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { useTranslation } from 'react-i18next'
import { setTripDirection } from '../../actions/formActions'
import './style.scss'
import { CHARTERS_DIRECTION_BOTH_WAY, CHARTERS_DIRECTION_ONE_WAY } from '../../consts/data'

const SearchChartersFilter = ({
    tripDirection,
    setTripDirection
}) => {
    const { t } = useTranslation()
    const filters = [];

    if (tripDirection === CHARTERS_DIRECTION_BOTH_WAY) filters.push(CHARTERS_DIRECTION_BOTH_WAY);
    const handleClick = (value) => {
        setTripDirection(value);
    };

    return (
        <>
            <input type="hidden" name="filters" value={filters.join(',')} />
            <ul className="trip-form-filters">
                <li
                    key={`filter-both-way`}
                    className={`trip-form-filter ${tripDirection === CHARTERS_DIRECTION_BOTH_WAY ? 'trip-form-filter--active' : ''}`}
                    onClick={() => handleClick(CHARTERS_DIRECTION_BOTH_WAY)}
                >
                    <span></span>
                    {t(`form.filters.both_way`)}
                </li>
                <li
                    key={`filter-one-way`}
                    className={`trip-form-filter ${tripDirection === CHARTERS_DIRECTION_ONE_WAY ? 'trip-form-filter--active' : ''}`}
                    onClick={() => handleClick(CHARTERS_DIRECTION_ONE_WAY)}
                >
                    <span></span>
                    {t(`form.filters.one_way`)}
                </li>
            </ul>
        </>
    )
}

const mapStateToProps = (state) => ({
    tripDirection: state.formReducer.tripDirection,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setTripDirection
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(SearchChartersFilter);
